import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { QuizQuestionType } from "@/models/quiz.model";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizReadonlyAlert from "@/components/quiz/QuizReadonlyAlert.vue";
import QuizCheckableTextQuestion from "@/components/quiz/QuizCheckableTextQuestion.vue";
import QuizSimpleTextQuestion from "@/components/quiz/QuizSimpleTextQuestion.vue";
import QuizUtils from "@/util/quizUtils";
let SurveyQuizQuestions = class SurveyQuizQuestions extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "quiz", void 0);
    _defineProperty(this, "userQuestionsAnswers", void 0);
    _defineProperty(this, "isResultMode", void 0);
    _defineProperty(this, "realtimeUserAnswers", null);
  }
  mounted() {
    this.realtimeUserAnswers = {
      contenuQuizId: this.quiz.id,
      questions: this.userQuestionsAnswers
    };
    if (this.quiz && !this.userQuestionsAnswers.length) {
      this.realtimeUserAnswers = this.initRealtimeUserAnswers(this.quiz);
    }
  }
  initRealtimeUserAnswers(quiz) {
    return {
      contenuQuizId: quiz.id,
      questions: quiz.questions?.map(question => ({
        questionId: question.id,
        questionType: question.type,
        order: question.order,
        blanksText: question.blanksText,
        responsesIds: [],
        responseContent: ''
      })) || []
    };
  }
  getQuestionTextType(question) {
    return question.type === QuizQuestionType.QUESTION_TEXTE ? 'text' : 'textarea';
  }
  getQuestionLabel(question) {
    return `${question.order}/${this.quiz?.nbQuestions} - ${question.label}`;
  }
  get userAnswers() {
    return question => {
      const questionResult = this.realtimeUserAnswers?.questions?.find(q => q.questionId === question.id);
      if (!questionResult) {
        return null;
      }
      if (question.type === QuizQuestionType.QUESTION_PARAGRAPHE || question.type === QuizQuestionType.QUESTION_TEXTE) {
        return questionResult.responseContent;
      }
      const answersIds = questionResult?.responsesIds || [];
      if (question.type === QuizQuestionType.QUESTION_CHOIX_MULTIPLE) {
        return answersIds;
      }
      return answersIds[0] || null;
    };
  }
  get quizQuestionsExist() {
    return this.quiz?.questions !== undefined && this.quiz?.questions.length > 0;
  }
  isCheckableQuestion(question) {
    return QuizUtils.isCheckableQuestion(question.type);
  }
  isTextQuestion(question) {
    return QuizUtils.isTextQuestion(question.type);
  }
  onSelectionChange(idQuestion, selected) {
    this.realtimeUserAnswers?.questions?.forEach(question => {
      if (question.questionId === idQuestion) {
        question.responsesIds = Array.isArray(selected) ? selected : [selected];
      }
    });
    this.emitQuizAnswers();
  }
  onTextAnswerChange(idQuestion, answer) {
    this.realtimeUserAnswers?.questions?.forEach(question => {
      if (question.questionId === idQuestion) {
        question.responseContent = answer;
      }
    });
    this.emitQuizAnswers();
  }
  emitQuizAnswers() {
    return this.realtimeUserAnswers;
  }
};
__decorate([Prop({
  required: true
})], SurveyQuizQuestions.prototype, "quiz", void 0);
__decorate([Prop({
  default: []
})], SurveyQuizQuestions.prototype, "userQuestionsAnswers", void 0);
__decorate([Prop({
  default: false
})], SurveyQuizQuestions.prototype, "isResultMode", void 0);
__decorate([Emit('answerChange')], SurveyQuizQuestions.prototype, "emitQuizAnswers", null);
SurveyQuizQuestions = __decorate([Component({
  components: {
    QuizSimpleTextQuestion,
    QuizCheckableTextQuestion,
    QuizReadonlyAlert,
    WInput,
    StandardButton
  }
})], SurveyQuizQuestions);
export default SurveyQuizQuestions;